/**
 * 首页轮播
 */
import React from 'react';
import { Input, Row, Col, Icon, Tooltip, Button, Select } from 'antd';
import PageLayout from '../../ui/PageLayout';
import http from '../../../axios/http';
import messager from '../../ui/messager';
import CarouselEdit from './CarouselEdit';
import DictSelect from '../../ui/DictSelect';
import { global_data } from '../../ui/auth'

class CarouselIndex extends React.Component {
    columns = [{
        title: '轮播描述',
        dataIndex: 'des',
        width: '10%',
    }, {
        title: '所属系统',
        dataIndex: 'typeStr',
        width: '10%',
    }, {
        title: '显示顺序',
        dataIndex: 'sequence',
        width: '10%',
    }, {
        title: '状态',
        dataIndex: 'state',
        width: '10%',
        format: {0:'正常',1 :'删除', 2:'停用'}
    }, {
        title: '操作',
        dataIndex: 'id',
        width: '10%',
        render: (text, record, index) => (
            <div>
                {global_data.authCode.includes("SYS_CAROUSEL_UPDATE")?
                <Tooltip title="修改">
                    <Icon type="edit" theme="filled" className="table-operate-icon" onClick={this.update.bind(this, record)} />
                </Tooltip>
                :""}
                {global_data.authCode.includes("SYS_CAROUSEL_DELETE")?
                <Tooltip title="删除">
                    <Icon type="delete" theme="filled" className="table-operate-icon" onClick={this.delete.bind(this, text)} />
                </Tooltip>
                :""}
                {global_data.authCode.includes("SYS_CAROUSEL_ENABLE")?
                <Tooltip title="启用">
                    <Icon type="check-circle" theme="filled" className="table-operate-icon" onClick={this.enable.bind(this, text)} />
                </Tooltip>
                :""}
                {global_data.authCode.includes("SYS_CAROUSEL_DISABLE")?
                <Tooltip title="停用">
                    <Icon type="stop" theme="filled" className="table-operate-icon" onClick={this.disable.bind(this, text)} />
                </Tooltip>
                :""}
            </div>
        ),
    }];

    state = {
        visible: false,
        editData: {},  //编辑的数据
        loadData: '',
        queryData: {}, //查询数据
        orgList: [], //市场信息
    };

    add = () => {
        this.setState({ visible: true, editData: {type: "0"} });
    }

    update = (info, e) => {
        let imageUrl = info.image;
        //读取缩略图
        http.post({
            url: '/common/getThumbnailImage',
            data: { url: imageUrl },
            success: (res) => {
                let data = {image: res, imageUrl: imageUrl};
                this.state.ref.initImage(data);
                this.setState({ visible: true, editData: info});
            }
        });
    }

    hiddenModal = () => {
        this.setState({ visible: false, editData: {} });
    }

    delete = (info, e) => {
        messager.confirm("是否删除该轮播信息？", () => {
            http.post({
                url: '/carousel/deleteCarousel',
                data: { id: info },
                success: (res) => {
                    this.state.loadData(this.state.queryData);
                    messager.notify("删除成功！");
                }
            });
        });
    }

    //启用
    enable = (info, e) => {
        messager.confirm("是否启用该数据轮播信息？", () => {
            http.post({
                url: '/carousel/enableCarousel',
                data: { id: info },
                success: (res) => {
                    this.state.loadData(this.queryData);
                    messager.notify("启用成功！");
                }
            });
        });
    }

    //停用
    disable = (info, e) => {
        messager.confirm("是否停用该轮播信息？", () => {
            http.post({
                url: '/carousel/disableCarousel',
                data: { id: info },
                success: (res) => {
                    this.state.loadData(this.queryData);
                    messager.notify("停用成功！");
                }
            });
        });
    }

    //查询
    inputSearch = (field, value) => {
        let queryData = this.state.queryData;
        queryData[field] = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData)
    }

    selectChange = (field, value) => {
        let queryData = this.state.queryData;
        queryData[field] = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={20}>
                                <Input.Search
                                    placeholder="轮播描述"
                                    onSearch={this.inputSearch.bind(this, "des")}
                                    enterButton
                                    style={{ width: '250px', marginRight: '10px' }}
                                />
                                <DictSelect category={"CAROUSEL_TYPE"} allowClear={true} style={{ width: 180, margin: '0 10px'}} onChange={this.selectChange.bind(this,"type")}/>

                                <Select onChange={this.selectChange.bind(this,"state")} allowClear={true} style={{ width: 180}}>
                                    <Select.Option key="0">正常</Select.Option>
                                    <Select.Option key="2">停用</Select.Option>
                                </Select>
                            </Col>
                            <Col span={4} style={{ textAlign: "right" }}>
                                {global_data.authCode.includes("SYS_CAROUSEL_ADD")?
                                <Button type="primary" onClick={this.add}>新增</Button>
                                :""}
                            </Col>
                        </Row>
                    )}
                    rowKey="id"
                    url="/carousel/findCarouselPage"
                    columns={this.columns}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                />
                <CarouselEdit
                    visible={this.state.visible}
                    onCancel={this.hiddenModal.bind(this)}
                    editData={this.state.editData}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}

                    onRef={(ref)=>{this.setState({ref: ref})}}
                />
            </div>
        )
    }

}

export default CarouselIndex;